/**
 * Process polyfill for browser environments
 * This file will be imported directly in the main entry point
 */

// Create a global process object if it doesn't exist
if (typeof window !== 'undefined' && !window.process) {
  window.process = {
    env: {
      NODE_ENV: 'production',
      // Add any other environment variables your app needs here
    },
    // Add any other process properties needed
    nextTick: (callback) => setTimeout(callback, 0),
    version: '',
    platform: 'browser',
    browser: true
  };
}

export default window.process;
